import React from 'react';
import config from 'config';

import SchedulingPageWrapper from 'containers/PublicSchedulingPage/components/SchedulingPageWrapper';
import { SELF_SCHEDULING_CLOSED_MESSAGE } from 'utils/constants';

/**
 * Shown to a participant without a session when the study has self-scheduling turned off.
 *
 * @param {Object} props
 * @param {string} [props.logo] Study branding logo
 * @param {Object} [props.account] Public account data (title, show_pfx_branding)
 */
const SchedulingPageClosed = ({ logo, account }) => (
    <SchedulingPageWrapper
        status="scheduling-closed"
        logo={logo || `${config.UI_SUFFIX}/dscout-private-panels-logo.svg`}
        account={account || {}}
    >
        <div data-testid="scheduling-closed">
            <h2 className="fs-headline-20 color-text-primary m-0 mb-3">This study isn't taking new bookings</h2>
            <p className="fs-body-14 color-text-secondary m-0">{SELF_SCHEDULING_CLOSED_MESSAGE}</p>
        </div>
    </SchedulingPageWrapper>
);

export default SchedulingPageClosed;
